import * as React from 'react';
import {
    IconClipboardText,
    IconHome,
    IconFileExport,
    IconBuildingBank,
    IconBuilding,
    IconId,
    IconSettings,
    IconUsers
} from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

// Local Components
import { Navbar } from '../Navbar';

export const NavbarAdmin: React.FC = () => {
    const { t } = useTranslation('routes', { keyPrefix: 'admin' });
    const config = React.useMemo(
        () => [
            { label: t('dashboard.label'), icon: IconHome, link: '/admin', end: true },
            { label: t('clients.label'), icon: IconBuilding, link: '/admin/clients' },
            { label: t('contacts.label'), icon: IconUsers, link: '/admin/contacts' },
            { label: t('export.label'), icon: IconFileExport, link: '/admin/export' },
            { label: t('loans.label'), icon: IconBuildingBank, link: '/admin/loans' },
            // { label: t('reports.label'), icon: IconId, link: '/admin/reports' },
            // { label: t('settings.label'), icon: IconSettings, link: '/admin/settings' },
            { label: t('surveys.label'), icon: IconClipboardText, link: '/admin/surveys' },
            { label: t('users.label'), icon: IconUsers, link: '/admin/users' }
        ],
        [t]
    );

    return <Navbar items={config} />;
};
